declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let gaInitialized = false;

function ensureGtag(measurementId: string): void {
  if (typeof window === "undefined" || gaInitialized) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  gaInitialized = true;
}

export function initGa4(measurementId: string): void {
  if (!measurementId.trim()) return;
  ensureGtag(measurementId);
}

export function ga4PageView(pathWithSearch: string): void {
  if (typeof window === "undefined" || !window.gtag) return;
  if (!import.meta.env.VITE_GA_MEASUREMENT_ID?.trim()) return;

  const pagePath = pathWithSearch || window.location.pathname + window.location.search;
  const pageLocation = `${window.location.origin}${pagePath}`;

  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: document.title,
  });
}
